/*
 * @Author: Tina Huang
 * @Date: 2023-03-07 10:52:29
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-03-07 10:52:31
 * @Description:
 */
export default {
  data() {
    return {
      lock: null,
      lockStatus: false,
    };
  },
  beforeDestroy() {
    this.lock && this.lock.close();
    this.lockStatus = false;
  },
  methods: {
    openFullScreen2(message) {
      this.lockStatus = true;
      this.lock = this.$loading({
        lock: true,
        text: message || "该组件未开放分享",
        spinner: "el-icon-warning",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "lock-box",
      });
    },
  },
};
